document.addEventListener('DOMContentLoaded', function () {
  const cartGiftOptionDrawer = document.querySelector('cart-gift-option-drawer');
  const closeGiftDrawerButton = document.getElementById('close-gift-drawer');
  const cancelGiftDrawerIcon = document.getElementById('cancel-gift-drawer-icon');

  $(document).on('click', '#open-gift-option-drawer, .cart-item__gift_box-edit-button-option', function () {
    openDrawer();
  });

  async function fetchGiftBoxCartItemsAndTotalPrice(itemsUrl, priceUrl) {
    try {
      // Fetch gift box cart items
      const itemsResponse = await fetch(itemsUrl);
      if (!itemsResponse.ok) {
        throw new Error(`HTTP Error! status: ${itemsResponse.status}`);
      }
      const itemsData = await itemsResponse.text();
      let htmlMarkup = new DOMParser()
        .parseFromString(itemsData, 'text/html')
        .querySelector('#shopify-section-cart-gift-option-drawer').innerHTML;
      let giftProdItems = document.querySelector('#gift-drawer-cart-items');
      giftProdItems.innerHTML = htmlMarkup;

      // Fetch cart total price
      const priceResponse = await fetch(priceUrl);
      if (!priceResponse.ok) {
        throw new Error(`HTTP Error! status: ${priceResponse.status}`);
      }
      const priceData = await priceResponse.text();
      let totalPriceElement = new DOMParser()
        .parseFromString(priceData, 'text/html')
        .querySelector('#shopify-section-cart-gift-option-footer').innerHTML;
      let cartTotalPrice = document.querySelector('#gift-drawer-cart-footer-total');
      cartTotalPrice.innerHTML = totalPriceElement;

      return { itemsData, priceData };
    } catch (error) {
      console.log('Error fetching the API');
      throw error;
    }
  }

  openDrawer = () => {
    cartGiftOptionDrawer.classList.add('open');
    addOverflowScroll();
    const giftCartItemsUrl = new URL(window.location);
    giftCartItemsUrl.searchParams.append('section_id', 'cart-gift-option-drawer');
    const urlString = giftCartItemsUrl.toString();
    giftCartItemsUrl.searchParams.append('section_id', 'cart-gift-option-footer');
    const urlPriceString = giftCartItemsUrl.toString();
    fetchGiftBoxCartItemsAndTotalPrice(urlString, urlPriceString);
  }

  closeDrawer = () => {
    cartGiftOptionDrawer.classList.remove('open');
    removeOverflowScroll();
  }

  addOverflowScroll = () => {
    document.body.classList.add('overflow-hidden--drawer-open');
    document.documentElement.classList.add('overflow-hidden--drawer-open');
  }

  removeOverflowScroll = () => {
    document.body.classList.remove('overflow-hidden--drawer-open');
    document.documentElement.classList.remove('overflow-hidden--drawer-open');
  }

  const giftOptionOverlay = document.getElementById('GiftOption-Overlay');

  if (giftOptionOverlay && cartGiftOptionDrawer) {
    giftOptionOverlay.addEventListener('click', function () {
      closeDrawer();
    });
  }

  if (closeGiftDrawerButton) {
    closeGiftDrawerButton.addEventListener('click', closeDrawer);
  }

  if (cancelGiftDrawerIcon) {
    cancelGiftDrawerIcon.addEventListener('click', closeDrawer);
  }
});
